module.exports = __webpack_public_path__ + "static/img/H3.9c7e75c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/H3.png
// module id = ffk0
// module chunks = 0